var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNatindaLogoReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 21,
    viewBox: "0 0 180 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3897_6386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.89 20.4095H13.93L1.49 1.78953V20.4095H0V0.0195312H2.05L14.4 18.6095V0.0195312H15.89V20.4095Z",
    fill: "#231916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1338 20.4102H45.3438L42.8438 13.8502H32.8037C32.4437 14.8802 32.0537 15.9702 31.6337 17.1202C31.2137 18.2702 30.8037 19.3602 30.4237 20.4102H28.8438C29.5138 18.6502 30.1737 16.9202 30.8237 15.2302C31.4737 13.5402 32.1238 11.8602 32.7738 10.1902C33.4238 8.52023 34.0638 6.84023 34.7238 5.15023C35.3738 3.46023 36.0338 1.74023 36.7038 -0.00976562H38.8037L47.1338 20.4002V20.4102ZM42.4237 12.6802L37.6937 1.34023L33.2038 12.6802H42.4237Z",
    fill: "#231916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7503 1.50953H68.6203V20.4095H67.1303V1.50953H60.0703V0.0195312H75.7503V1.50953Z",
    fill: "#231916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1462 20.4095H88.6562V0.0195312H90.1462V20.4095Z",
    fill: "#231916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.023 20.4095H117.063L104.623 1.78953V20.4095H103.133V0.0195312H105.183L117.533 18.6095V0.0195312H119.023V20.4095Z",
    fill: "#231916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.452 10.0591C148.452 16.9591 145.022 20.4191 138.152 20.4191H131.992V0.0390625H138.152C141.592 0.0390625 144.172 0.869063 145.882 2.52906C147.592 4.18906 148.452 6.69906 148.452 10.0591ZM146.872 10.0591C146.872 8.71906 146.742 7.51906 146.472 6.46906C146.202 5.40906 145.732 4.51906 145.062 3.77906C144.392 3.03906 143.492 2.47906 142.372 2.08906C141.252 1.69906 139.832 1.50906 138.112 1.50906H133.472V18.9191H138.112C139.812 18.9191 141.222 18.7191 142.352 18.3191C143.472 17.9191 144.372 17.3391 145.042 16.5791C145.712 15.8191 146.182 14.8891 146.462 13.7991C146.732 12.7091 146.872 11.4591 146.872 10.0591Z",
    fill: "#231916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.688 20.4102H177.898L175.398 13.8502H165.358C164.998 14.8802 164.608 15.9702 164.188 17.1202C163.768 18.2702 163.358 19.3602 162.978 20.4102H161.398C162.068 18.6502 162.728 16.9202 163.378 15.2302C164.028 13.5402 164.678 11.8602 165.328 10.1902C165.978 8.52023 166.618 6.84023 167.278 5.15023C167.928 3.46023 168.588 1.74023 169.258 -0.00976562H171.358L179.688 20.4002V20.4102ZM174.978 12.6802L170.248 1.34023L165.758 12.6802H174.978Z",
    fill: "#231916"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3897_6386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179.69,
    height: 20.41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatindaLogoReceipt);
export default __webpack_public_path__ + "static/media/Natinda-Logo-Receipt.57b47bf227f79765677d61d114387e51.svg";
export { ForwardRef as ReactComponent };